<template>
  <div>
    <password-dialog v-model="showPasswordDialog" />
    <v-container fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <v-flex xs12 sm5 md3>
          <base-card v-if="$auth.currentUser" color="secondary">
            <profile-image
              v-if="$auth.currentUser && $auth.currentUser.isArtist"
            />
            <div v-else class="text-xs-center">
              <v-img src="/static/img/user.png" />
            </div>

            <div class="pa-3">
              <h1 class="headline font-weight-bold">
                {{ $auth.currentUser.name }}
              </h1>
              <h2 class="subheading">{{ $auth.currentUser.email }}</h2>
            </div>

            <v-list dense>
              <!-- Account -->
              <v-list-tile
                :to="{ name: 'profile.account' }"
                active-class="primary"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $t("COMMON.ACCOUNT")
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <template v-if="$auth.currentUser.isArtist">
                <v-list-group :value="true">
                  <template v-slot:activator>
                    <!-- My artworks -->
                    <v-list-tile>
                      <v-list-tile-title>{{
                        $t("COMMON.MY_ARTWORKS")
                      }}</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <!-- Published artworks -->
                  <v-list-tile
                    :to="{ name: 'profile.artworks' }"
                    active-class="primary"
                    exact
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        $t("ACCOUNT.PUBLISED_ARTWORKS")
                      }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-badge color="primary" left>
                        <template v-slot:badge>
                          <span>{{
                            $auth.currentUser.artworksPublishedCount
                          }}</span>
                        </template>
                      </v-badge>
                    </v-list-tile-action>
                  </v-list-tile>

                  <!-- Draft artworks -->
                  <v-list-tile
                    :to="{ name: 'profile.artworks.draft' }"
                    active-class="primary"
                    exact
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        $t("ACCOUNT.DRAFT_ARTWORKS")
                      }}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-badge color="primary" left>
                        <template v-slot:badge>
                          <span>{{
                            $auth.currentUser.artworksDraftCount
                          }}</span>
                        </template>
                      </v-badge>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>

                <!-- Sales -->
                <v-list-tile
                  :to="{ name: 'profile.sales' }"
                  active-class="primary"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $tc("COMMON.SALE", 2)
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-badge color="primary" left>
                      <template v-slot:badge>
                        <span>{{ $auth.currentUser.salesCount }}</span>
                      </template>
                    </v-badge>
                  </v-list-tile-action>
                </v-list-tile>

                <!-- Receipts -->
                <v-list-tile
                  :to="{ name: 'profile.receipts' }"
                  active-class="primary"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      $t("RECEIPTS.TITLE")
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <!-- Favorites -->
              <v-list-tile
                :to="{ name: 'profile.favorites' }"
                active-class="primary"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $tc("COMMON.FAVORITE", 2)
                  }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-badge color="primary" left>
                    <template v-slot:badge>
                      <span>{{ $auth.currentUser.favoritesCount }}</span>
                    </template>
                  </v-badge>
                </v-list-tile-action>
              </v-list-tile>

              <!-- Subscriptions -->
              <v-list-tile
                :to="{ name: 'profile.subscriptions' }"
                active-class="primary"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $t("Followed artists")
                  }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-badge color="primary" left>
                    <template v-slot:badge>
                      <span>{{ $auth.currentUser.subscriptions_count }}</span>
                    </template>
                  </v-badge>
                </v-list-tile-action>
              </v-list-tile>

              <!-- Purchases -->
              <v-list-tile
                v-if="!$auth.currentUser.isArtist"
                :to="{ name: 'profile.purchases' }"
                active-class="primary"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $tc("COMMON.PURCHASE", 2)
                  }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-badge color="primary" left>
                    <template v-slot:badge>
                      <span>{{ $auth.currentUser.purchasesCount }}</span>
                    </template>
                  </v-badge>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>

            <v-divider />

            <!-- Practical information -->
            <v-list dense  v-if="$auth.currentUser.isArtist">
              <v-list-tile
                :to="{ name: 'profile.pracitcal-information' }"
                active-class="primary"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $t("ACCOUNT.PRACTICAL_INFO")
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <!-- / Practical information -->

            <v-divider />

            <tk-btn flat small @click="showPasswordDialog = true">{{
              $t("COMMON.CHANGE_PASSWORD")
            }}</tk-btn>
            <tk-btn flat small @click="logout">{{
              $t("COMMON.LOGOUT")
            }}</tk-btn>
          </base-card>
        </v-flex>
        <v-flex xs12 sm7 md9 py-0>
          <!-- Impersonate -->
          <v-alert v-if="impersonated" :value="true" color="error">
            <v-layout align-center row>
              <v-flex>
                <span>You are currently impersonating &nbsp;</span>
                <strong>{{ impersonated.slug }}.</strong>
              </v-flex>
              <v-flex ma-0 pa-0 shrink>
                <tk-btn @click="logout" color="white" flat small>Stop</tk-btn>
              </v-flex>
            </v-layout>
          </v-alert>

          <artist-impersonate @success="impersonateSucess" />

          <router-view :key="routerKey" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LocalStorage from "../../utils/LocalStorage";
import { STORE_IMPERSONATE } from "../../AppKeys";

export default {
  components: {
    PasswordDialog: () => import("./PasswordDialog"),
    ProfileImage: () => import("./ProfileImage"),
    ArtistImpersonate: () => import("./ArtistImpersonate"),
  },

  data() {
    return {
      showPasswordDialog: false,
      routerKey: 1,
      impersonated: null,
    };
  },

  mounted() {
    const res = LocalStorage.get(STORE_IMPERSONATE);
    if (res) {
      console.log("Impersonate", res.slug);
      this.impersonated = res;
    }
  },

  methods: {
    logout() {
      this.$auth.logout();
      this.$router.replace({ name: "home" });
      LocalStorage.remove(STORE_IMPERSONATE);
      this.impersonated = null;
    },
    impersonateSucess(e) {
      console.log("impersonate success", e);
      console.log(e);
      this.routerKey++;
      this.impersonated = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list {
  background-color: transparent !important;
}
.primary {
  .v-list__tile__content {
    color: white;
  }
}
</style>
